import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';

import {Observable} from 'rxjs';
import { Menu, SubMenu } from '../models/menu';
import 'rxjs/add/operator/map';

/**
    * Loads the left-side navigation menu-list along with routes and help content from /src/assets/Data/menu.json file.
    *
     * See {@link Menu} for more details.
      */
@Injectable()
export class CommonService {

 constructor (    private http: Http  ) {
 }

  getMenuContent(): Observable<Menu[]> {
    return this.http.get('../../assets/Data/menu.json')
    .map(mapMenu);
    // .catch((error: any) => Observable.throw( 'Server error'));
  }

  getMenuEdgeContent(): Observable<Menu[]> {
    return this.http.get('../../assets/Data/menuedge.json')
    .map(mapMenu);
    // .catch((error: any) => Observable.throw( 'Server error'));
  }
}






 function mapMenu(response: Response): Menu[] {
   // The response of the API has a results
   // property with the actual results
  // console.log("response:",response.json());
   return response.json().map(extractMenu);
}

 function extractMenu(r: Menu): Menu {
  const menu = <Menu>({

    description: r.description,
    icon: r.icon,
    pageToLoad: r.pageToLoad,
    name: r.name,
    operationID: r.operationID,
    helpDocPath: r.helpDocPath,
    subMenu: (r.subMenu != null && r.subMenu.length > 0 ) ? extractSubMenu(r.subMenu) : []
  });
//  console.log('Parsed menu:', menu);
  return menu;
}

 function extractSubMenu(data: any): SubMenu[] {
return  data.map(getSubMenu);

}

 function getSubMenu(content: SubMenu): SubMenu {
 const subMenu = <SubMenu>({
    description: content.description,
    icon: content.icon,
    pageToLoad: content.pageToLoad,
    name: content.name,
    subOperationID: content.subOperationID
  });
    return subMenu;
}
